import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import twinFetchPost from '../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../utils/reducers/reduxDispatch'
import { OrderData } from '../../../../../inputTableLayouts/order/OrderLayout/types'
import { parseRefundSelectedTableForProcessing } from '../../../../../inputTableLayouts/order/OrderLayout/useMultiOrderRefundLogic/functions'
import ModalSmallFilled from '../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'

type ModalOrderRefundProcessProps = ModalOrderRefundProcessLogicProps & { 
    translations: {
        title: string
        subtitle: string
    }
}

const ModalOrderRefundProcess: React.FC<ModalOrderRefundProcessProps> = ({ setOpened, data, translations,  ...logic}) => {
    const { finalizeOrder, loading } = useModalOrderRefundProcessLogic({ data, setOpened, ...logic })
    const { t } = useTwinTranslation()
    
    return (
        <ModalSmallFilled opened={true} setOpened={() => {}} onClickOut={false} translations={{ ...translations, buttonAccept: t('create', 'Crear') }} onAccept={finalizeOrder} loading={loading} onCancel={() => setOpened(null)} />
    )
}

interface ModalOrderRefundProcessLogicProps {
    setOpened: ModalOpenedSetTy
    data: OrderData
    urlProcess: string
    urlNavigate: string
}

const useModalOrderRefundProcessLogic = ({ data, setOpened, urlNavigate, urlProcess }: ModalOrderRefundProcessLogicProps) => {
    const { t } = useTwinTranslation()
    const {loading, startLoading} = useIsLoading()
    const navigate = useNavigate()
    const notSelectedProducts = t('notSelectedProducts', 'No has seleccionado ningún producto.')
    const notRefundDate = t('notRefundDate', 'Hay una factura que no está en plazo de devolución')
    const finalizeOrder = useCallback(async () => {
        startLoading()
        const selectedProducts = parseRefundSelectedTableForProcessing(data)
        if (selectedProducts.forSend.products?.length) {
            const response = await twinFetchPost(urlProcess, { selectedProducts: selectedProducts.forSend.products, sellInfo: {...data.header} })
            const responseJSON = await response.json()
            if (response.status === 200) {
                if (responseJSON !== false) {
                    navigate(urlNavigate + '/' + responseJSON.id)
                }
            } else {
                if (responseJSON.errors[0].msg === 'Cannot refund because of date') {
                    changeErrorMessage(notRefundDate)
                } else {
                    changeErrorMessage(responseJSON.errors[0].msg)
                }
            }
        } else {
            changeErrorMessage(notSelectedProducts)
        }
        setOpened(null)
    }, [navigate, setOpened, data, startLoading, urlNavigate, urlProcess, notSelectedProducts, notRefundDate])
    
    return { finalizeOrder, loading }

}

export default ModalOrderRefundProcess